import React, {useEffect, useState} from 'react';
import ArchiveTable from "../../../../components/UI/table/orders/organization/archive/ArchiveTable";
import Typography from "@mui/material/Typography";
import OrderService from "../../../../API/orders/orders/organization/OrderService";
import DataUtil from "../../../../utils/common/DataUtil";
import OrderUtil from "../../../../utils/orders/OrderUtil";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import {Box} from "@mui/system";
import {constantsErrorMessages} from "../../../../Constants";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";
import {calcFilterData} from "../../../../utils/common/calcFilterData";
import {ArchiveTableFilterData} from "../../../../data/FilterTables/ArchiveTableFilterData";
import {EMPTY_CUSTOMER_NUMBER_FILTER, EMPTY_ORDER_NUMBER_FILTER, EMPTY_CUSTOMER_FILTER, EMPTY_HEADER_FILTER, EMPTY_ATTRIBUTES_BLANK_FILTER, EMPTY_CONSTRUCTOR_FILTER, EMPTY_TECHNOLOGIST_FILTER, EMPTY_MODEL_FILTER, EMPTY_ARCHIVE_STATE_FILTER} from "../../../../data/OrderStatus";

const ArchiveNotImplemented = () => {
    const [data, setData] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const [nameList, setNameList] = useState([]);
    const [modelList, setModelList] = useState([]);
    const [attributeList, setAttributeList] = useState([]);
    const [planningList, setPlanningList] = useState([]);
    const [constructorList, setConstructorList] = useState([]);
    const [technologistList, setTechnologistList] = useState([]);
    const [numberList, setNumberList] = useState([]);
    const [numberCustomerList, setNumberCustomerList] = useState([]);
    const [alertData, setAlertData] = useState({});
    const [filteredData, setFilteredData] = useState(data)
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData("organization/archive", "pageSize", nextState.pageSize)
        }
    }

    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, ArchiveTableFilterData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [ArchiveTableFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(`organization/archive`, "searchQuery", searchQuery)
            }
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`organization/archive`]?.pageSize
        const searchQuery = pagesData[`organization/archive`]?.searchQuery

        return {searchQuery, pageSize}
    }
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const setLists = (data) => {
        setCustomerList(DataUtil.getListChildField(data, 'customerOrder', 'name', EMPTY_CUSTOMER_FILTER));
        setNameList(DataUtil.getListChildField(data, 'header', 'name', EMPTY_HEADER_FILTER));
        setModelList(DataUtil.getListChildField(data, 'modelOrder', 'name', EMPTY_MODEL_FILTER));
        setConstructorList(DataUtil.getListChildField(data, 'constructor', 'name', EMPTY_CONSTRUCTOR_FILTER));
        setTechnologistList(DataUtil.getListChildField(data, 'technologist', 'name', EMPTY_TECHNOLOGIST_FILTER));
        setAttributeList(OrderUtil.getStatuses(data, 'attributes', EMPTY_ATTRIBUTES_BLANK_FILTER));
        setPlanningList(DataUtil.getListField(data, 'state', EMPTY_ARCHIVE_STATE_FILTER));
        setNumberList(DataUtil.getListField(data, 'number', EMPTY_ORDER_NUMBER_FILTER));
        setNumberCustomerList(DataUtil.getListField(data, 'numberCustomer', EMPTY_CUSTOMER_NUMBER_FILTER));
    }
    useEffect(() => {
        const {searchQuery, pageSize} = getStartPageSize()
        OrderService.getOrdersNotImplemented().then(function (response) {
            setData(response.data);
            handleSearchQuery(searchQuery, response.data, pageSize)
            setLists(response.data)
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);
    return (
        <Box sx={{padding: "0 30px"}}> <BreadcrumbsComponent
            page={"Нереализованные"}
            path={[
                {name: "Главная", href: "/"},
                {name: "Архив заказов", href: "/organization/archive"},
            ]}/>
            <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                Нереализованные
            </Typography>
            <ArchiveTable
                data={data} setData={setData} customerList={customerList} nameList={nameList}
                modelList={modelList}
                attributeList={attributeList}
                planningList={planningList} constructorList={constructorList} technologistList={technologistList}
                numberList={numberList} numberCustomerList={numberCustomerList}
                tableOptions={tableOptions} tableOptionsHandle={tableOptionsHandle} notImplemented={true}
                globalFilter={globalFilter}
                filteredData={filteredData}
                handleSearchQuery={handleSearchQuery}
                columnsFilter={columnsFilter}
                setLists={setLists}/>
            <ModalAlert
                data={alertData}
                onClose={() => setAlertData((alert) => ({...alert, open: false}))}
            />
        </Box>
    );
};

export default ArchiveNotImplemented;